import { GiBrain } from "react-icons/gi";

export default function App() {
  return (
    <div className="app">
      <p>brndmp.</p>
      <GiBrain className="brain-svg"/>
    </div>
  );
}